export enum ChatFilterType {
  ALL = 'All',
  MINE = 'Mine',
}

export enum ChatMessageType {
  TEXT = 'Text',
  ACTION = 'Action',
  APPOINTMENT = 'Appointment',
  APPOINTMENT_CANCELLED = 'AppointmentCancelled',
  APPOINTMENT_RESCHEDULED = 'AppointmentRescheduled',
  APPOINTMENT_QA = 'QaWithAppointment',
  FILE = 'File',
  QA = 'Qa',
  MIND = 'Mind',
  STATUS = 'Status',
}

export enum ChatMessagePostedByType {
  SYSTEM = 'SYSTEM',
  HEALTH_PROFESSIONAL = 'HEALTH_PROFESSIONAL',
  PATIENT = 'PATIENT',
  GENERAL_PRACTICE = 'GENERAL_PRACTICE',
}

export enum ChatMessageActionType {
  DEFAULT = 'DEFAULT',
  URINE_QUESTIONNAIRE = 'URINE_QUESTIONNAIRE',
  EXPLAIN_COMPLAINT = 'EXPLAIN_COMPLAINT',
  APPOINTMENT = 'APPOINTMENT',
  APPOINTMENT_MISSED = 'APPOINTMENT_MISSED',
  APPOINTMENT_NO_SHOW = 'APPOINTMENT_NO_SHOW',
}

export enum ChatMessageActionStatus {
  ACTIVE = 'Active',
  INACTIVE = 'InActive',
  COMPLETED = 'Completed',
  REMOVED = 'Removed',
}

export enum ChatMessageAppointmentStatus {
  ACTIVE = 'Active',
  INACTIVE = 'InActive',
  COMPLETED = 'Completed',
  REMOVED = 'Removed',
  CANCELED = 'Canceled',
  RESCHEDULED = 'Rescheduled',
}

export enum AgendaAppointmentModalAction {
  DEFAULT = 'DEFAULT',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}

export enum BulkMessagePatientsModalFilter {
  ALL = 'ALL',
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  NOT_SENT = 'NOT-SENT',
  SENT = 'SENT',
}
